import styled, { css } from 'styled-components';
import { rgba } from 'polished';
import colors from '../../constants/colors';

import openEye from './ic_visible_pass.svg';
import closeEye from './ic_hidden_pass.svg';

const Wrapper = styled.div`
  position: relative;
  height: 55px;
  width: 100%;
`;

const Icon = styled.i`
  cursor: pointer;
  display: block;
  margin-right: 10px;
  background: url(${(props) => (props.show ? openEye : closeEye)}) 50% 50% no-repeat;
  background-size: contain;
  height: 25px;
  width: 25px;
  flex-shrink: 0;
`;

const Label = styled.label`
  background: #fff;
  display: flex;
  align-items: center;
  position: absolute;
  padding-right: 10px;
  top: 0;
  bottom: 1px;
  padding-top: 3px;
  left: 0;
  text-align: left;

  &:after {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: linear-gradient(
      90deg,
      ${rgba(colors.main.white, 0.9)},
      ${rgba(colors.main.white, 0)}
    );
    left: 100%;
    height: 20px;
    width: 32px;
  }
`;

const Input = styled.input`
  font-size: 16px;
  font-weight: 400;
  border-bottom: 1px solid ${colors.main.dividers};
  white-space: nowrap;
  word-break: keep-all;
  height: 100%;
  width: 100%;
  text-align: ${(props) => (props.alignLeft ? 'left' : 'right')};

  &:focus {
    border-bottom: 1px solid ${colors.main.placeholdersAndDisabledBtnsText};
  }

  ${(props) =>
    props.error || props.errorMessage
      ? css`
          border-bottom: 1px solid ${colors.main.ruby} !important;
        `
      : null}

  &[type="password"] {
    & + label {
      ${'' /* width: 120px; */}
    }
  }
`;

const Error = styled.div`
  bottom: 0;
  position: absolute;
  transform: translateY(100%);
  z-index: 10;
`;

const Tip = styled.div`
  bottom: -5px;
  position: absolute;
  transform: translateY(100%);
  z-index: 10;
`;

export { Wrapper, Input, Label, Error, Tip, Icon };
